import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import relevant from './../../img/icons/relevant@3x.png';
import reliable from './../../img/icons/reliable@3x.png';
import required from './../../img/icons/required@3x.png';

import wikipedia from './../../img/tutorial/wikipedia@3x.png';
import medium from './../../img/tutorial/medium@3x.png';
import sparknotes from './../../img/tutorial/sparknotes@3x.png';

class TutorialStep3 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step3)}>

        <h3>Minimum Requirements: </h3>
        <b>1 double-spaced page (300 words) = 1 source</b>

        <i className={baseStyles.tutorial_devider} />

        <div className={classnames(grid.row, baseStyles.mb_50)}>

          <div className={grid.col_4}>
            <img src={required} alt="required" width="40px" />
            <h3>Required:</h3>
            <p>All sources attached or <br /> mentioned in the <br />instructions</p>
          </div>

          <div className={grid.col_4}>
            <img src={relevant} alt="relevant" width="40px" />
            <h3>Relevant:</h3>
            <p>Up-to-date sources (published within the last 5-7 years)</p>
          </div>

          <div className={grid.col_4}>
            <img src={reliable} alt="reliable" width="40px" />
            <h3>Reliable:</h3>
            <p>Scholarly articles, books</p>
            <div>
              <h4>Websites where you can find reliable sources:</h4>
              <ul>
                <li><a href="http://scholar.google.com.ua" target="_blank" rel="noopener noreferrer">www.scholar.google.com.ua</a></li>
                <li><a href="http://researchgate.net" target="_blank" rel="noopener noreferrer">www.researchgate.net</a></li>
                <li><a href="http://ncbi.nlm.nih.gov" target="_blank" rel="noopener noreferrer">www.ncbi.nlm.nih.gov</a></li>
                <li><a href="http://jstor.org" target="_blank" rel="noopener noreferrer">www.jstor.org</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className={classnames(baseStyles.content_danger, baseStyles.content_dark_danger)}>
          <span className={classnames(baseStyles.ribbon_flag, baseStyles.success)}>
            NOTA BENE
          </span>

          <div className={classnames(grid.row, baseStyles.mb_10)}>
            <div className={classnames(grid.col_4, baseStyles.centered)}>
              <h5>Wikipedia</h5>
              <img src={wikipedia} alt="wikipedia" width="186px" />
            </div>
            <div className={classnames(grid.col_4, baseStyles.centered)}>
              <h5>Blogs</h5>
              <img src={medium} alt="medium" width="118px" />
            </div>
            <div className={classnames(grid.col_4, baseStyles.centered)}>
              <h5>Sparknotes</h5>
              <img src={sparknotes} alt="sparknotes" width="175px" />
            </div>
          </div>

          <div className={baseStyles.footer_danger}>should NOT be used for writing academic papers</div>
        </div>
      </div>
    )
  }
}

export default TutorialStep3;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep3.js